/** Dossier sections — `userHint` is plain-language help for officers */
export const APP_TAB_ROUTES = [
  {
    path: "overview",
    label: "Overview",
    desc: "Summary of this file and quick links",
    userHint: "See where this case stands and jump to the right section in one click.",
  },
  {
    path: "beneficiary",
    label: "Beneficiary & documents",
    desc: "What the citizen submitted from the mobile app",
    userHint: "Read-only: name, IDs, bank details, and document list from the field.",
  },
  {
    path: "validation",
    label: "Verification & Aadhaar seeding",
    desc: "Office checks before banking",
    userHint: "Mark each check, apply holds if needed, then confirm seeding before ICICI.",
  },
  {
    path: "banking",
    label: "ICICI & MOU",
    desc: "Account details and signed MOU",
    userHint: "Unlocked after seeding is confirmed. Save when account number, IFSC, and MOU file are ready.",
  },
  {
    path: "subcontractor",
    label: "Subcontractor",
    desc: "Pick firm from master (optional work order)",
    userHint:
      "After prior steps are done, select the firm from the onboarded list. You may attach this beneficiary’s work order or engagement letter when available. Register new firms under Subcontractor Onboarding in the main menu.",
  },
  {
    path: "engineer",
    label: "Engineer",
    desc: "Assign site engineer from master roster",
    userHint:
      "Pick the engineer responsible for this beneficiary from the Engineer master list. Register engineers under Engineer onboarding in the Masters menu if needed.",
  },
  {
    path: "work-progress",
    label: "Work Progress",
    desc: "Gantt chart, materials, and bills for this beneficiary",
    userHint: "Track construction timeline progress, view material allocations, and monitor bill status for this file.",
  },
  {
    path: "po-register",
    label: "PO Register",
    desc: "Purchase order history for this beneficiary",
    userHint: "All POs raised for this beneficiary — milestone, resource, items, quantities, and issue status.",
  },
  {
    path: "milestones",
    label: "Milestones",
    desc: "Progress against global milestone master (per beneficiary)",
    userHint:
      "Checklist comes from Milestone master. Mark each required material or bill done for this file; link work-done bills from the Bills tab where needed.",
  },
  {
    path: "bills",
    label: "Bills",
    desc: "Work-done bills and site re-check of seeding",
    userHint: "Upload a bill reference, then ask the site officer to confirm seeding again for each bill.",
  },
] as const;

export type AppTabPath = (typeof APP_TAB_ROUTES)[number]["path"];
